import { getJurisdictionCompany,addJurisdictionCompany,deleteJurisdictionCompany,uploadJurisdictionCompany,getJurisdictionCar,getJurisdictionDriver } from "../../api/config/modules/JurisdictionalCompanies";

const state = {
    getJurisdictionCompany: {},
    addJurisdictionCompany: {},
    deleteJurisdictionCompany: {},
    uploadJurisdictionCompany: {},
    getJurisdictionCar: {},
    getJurisdictionDriver: {}
};

const mutations = {
    SET_GETJURISDICTIONCOMPANY: (state, getJurisdictionCompany) => {
        state.getJurisdictionCompany = getJurisdictionCompany;
    },
    SET_ADDJURISDICTIONCOMPANY: (state, addJurisdictionCompany) => {
        state.addJurisdictionCompany = addJurisdictionCompany;
    },
    SET_DELETEJURISDICTIONCOMPANY: (state, deleteJurisdictionCompany) => {
        state.deleteJurisdictionCompany = deleteJurisdictionCompany;
    },
    SET_UPLOADJURISDICTIONCOMPANY: (state, uploadJurisdictionCompany) => {
        state.uploadJurisdictionCompany = uploadJurisdictionCompany;
    },
    SET_GETJURISDICTIONCAR: (state, getJurisdictionCar) => {
        state.getJurisdictionCar = getJurisdictionCar;
    },
    SET_GETJURISDICTIONDRIVER: (state, getJurisdictionDriver) => {
        state.getJurisdictionDriver = getJurisdictionDriver;
    },
};

const actions = {
    GET_GETJURISDICTIONCOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getJurisdictionCompany(data)
                .then((res) => {
                    commit("SET_GETJURISDICTIONCOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDJURISDICTIONCOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addJurisdictionCompany(data)
                .then((res) => {
                    commit("SET_ADDJURISDICTIONCOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEJURISDICTIONCOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteJurisdictionCompany(data)
                .then((res) => {
                    commit("SET_DELETEJURISDICTIONCOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPLOADJURISDICTIONCOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            uploadJurisdictionCompany(data)
                .then((res) => {
                    commit("SET_UPLOADJURISDICTIONCOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETJURISDICTIONCAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getJurisdictionCar(data)
                .then((res) => {
                    commit("SET_GETJURISDICTIONCAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETJURISDICTIONDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getJurisdictionDriver(data)
                .then((res) => {
                    commit("SET_GETJURISDICTIONDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
